import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from '@/firebase';

function getInventoryFunctions() {
  return getFunctions(app, 'us-central1');
}

function callableErrorMessage(err) {
  if (typeof err?.message === 'string' && err.message.trim()) {
    return err.message;
  }
  if (typeof err?.details === 'string' && err.details.trim()) {
    return err.details;
  }
  return 'Não foi possível concluir a operação de estoque.';
}

/**
 * @param {string} appointmentId
 */
export async function revertAppointmentInventory(appointmentId) {
  const fn = httpsCallable(getInventoryFunctions(), 'revertAppointmentInventory');
  try {
    const result = await fn({ appointmentId });
    return result.data;
  } catch (err) {
    throw new Error(callableErrorMessage(err));
  }
}

/**
 * @param {string} appointmentId
 */
export async function retryAppointmentInventory(appointmentId) {
  const fn = httpsCallable(getInventoryFunctions(), 'retryAppointmentInventory');
  try {
    const result = await fn({ appointmentId });
    return result.data;
  } catch (err) {
    throw new Error(callableErrorMessage(err));
  }
}

/**
 * @param {string} appointmentId
 * @param {Array} supplyUsage
 * @param {Array} containerEvents
 */
export async function updateAppointmentSupplies(appointmentId, supplyUsage, containerEvents) {
  const fn = httpsCallable(getInventoryFunctions(), 'updateAppointmentSupplies');
  try {
    const result = await fn({ appointmentId, supplyUsage, containerEvents });
    return result.data;
  } catch (err) {
    throw new Error(callableErrorMessage(err));
  }
}
